import {
  newSlice,
  _fetchEntitiesService,
  _loadEvents,
  _updateEntityService,
} from "./common/sliceFunctions2";

var entitiesName = "recordWithProducts";

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

export function fetchEntitiesService(dataSlice) {
  dataSlice.dataUrl.code = "GET_RECORD_WITH_PRODUCTS";
  dataSlice.dataUrl.oid = dataSlice.orgId ? dataSlice.orgId : null;

  return _fetchEntitiesService(dataSlice, events);
}

export function updateEntityService(dataSlice) {
  dataSlice.dataUrl.code = "PUT_RECORDPRODUCT";
  return _updateEntityService(dataSlice, events);
}
